import useModalProps from "../hooks/useModalProps";

function ErrorModal(props) {
    const { title, text, closeText, onClose } = useModalProps('reactErrorModal', props, { 
        title: undefined,
        text: undefined, 
        closeText: undefined,
        onClose: undefined
    })
    
    return (
        <React.Fragment>
            <div className="modal-title text-center">
                {title || __('common.error.title')}
            </div>
            <div className="modal-text text-center" dangerouslySetInnerHTML={{ __html: text }} />
            <div className="modal-btn">
                <a role="button" className="button button-base" data-fancybox-close onClick={() => onClose && onClose()}>{ closeText || "OK"}</a>
            </div>
        </React.Fragment>
    );
}

const domContainer = document.querySelector ( "#reactErrorModal" );
const root = ReactDOM.createRoot ( domContainer );
root.render(React.createElement(ErrorModal));
